import config from '../config';
import { customFetch, authHeader, jsonHeader, handleResponse, commonRequestOptions } from '../helpers';

const endpointPath = 'network/company'

export const companyService = {
    getAll,
    search,
    getByUuid,
    create,
    getOrCreate,
    update,
    destroy,
    addLink,
    updateLink,
    removeLink,
};

function getAll(signal) {
    const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
    return customFetch(`${config.api.url}/${endpointPath}/all`, requestOptions, signal).then(handleResponse);
}

function search(q, signal) {
    const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
    return customFetch(`${config.api.url}/${endpointPath}/search?q=${encodeURIComponent(q || '')}`, requestOptions, signal).then(handleResponse);
}

function getByUuid(uuid, signal) {
    const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
    return customFetch(`${config.api.url}/${endpointPath}/${uuid}`, requestOptions, signal).then(handleResponse);
}

function create(item, signal) {
    const requestOptions = { method: 'POST', headers: { ...authHeader(), ...jsonHeader() }, ...commonRequestOptions(), body: JSON.stringify(item) };
    return customFetch(`${config.api.url}/${endpointPath}`, requestOptions, signal).then(handleResponse);
}

function getOrCreate(item, signal) {
    const requestOptions = { method: 'POST', headers: { ...authHeader(), ...jsonHeader() }, ...commonRequestOptions(), body: JSON.stringify(item) };
    return customFetch(`${config.api.url}/${endpointPath}/get-or-create`, requestOptions, signal).then(handleResponse);
}

function update(uuid, item, signal) {
    const requestOptions = { method: 'PUT', headers: { ...authHeader(), ...jsonHeader() }, ...commonRequestOptions(), body: JSON.stringify(item) };
    return customFetch(`${config.api.url}/${endpointPath}/${uuid}`, requestOptions, signal).then(handleResponse);
}

function destroy(uuid, signal) {
    const requestOptions = { method: 'DELETE', headers: { ...authHeader(), ...jsonHeader() }, ...commonRequestOptions() };
    return customFetch(`${config.api.url}/${endpointPath}/${uuid}`, requestOptions, signal).then(handleResponse);
}

function addLink(uuid, link, signal) {
    const requestOptions = { method: 'POST', headers: { ...authHeader(), ...jsonHeader() }, ...commonRequestOptions(), body: JSON.stringify(link) };
    return customFetch(`${config.api.url}/${endpointPath}/${uuid}/links`, requestOptions, signal).then(handleResponse);
}

function updateLink(uuid, linkId, link, signal) {
    const requestOptions = { method: 'PUT', headers: { ...authHeader(), ...jsonHeader() }, ...commonRequestOptions(), body: JSON.stringify(link) };
    return customFetch(`${config.api.url}/${endpointPath}/${uuid}/links/${linkId}`, requestOptions, signal).then(handleResponse);
}

function removeLink(uuid, linkId, signal) {
    const requestOptions = { method: 'DELETE', headers: { ...authHeader(), ...jsonHeader() }, ...commonRequestOptions() };
    return customFetch(`${config.api.url}/${endpointPath}/${uuid}/links/${linkId}`, requestOptions, signal).then(handleResponse);
}
